export enum ListingsActionTypes {
  GET_LISTINGS = 'GET_LISTINGS',
  GET_LISTING = 'GET_LISTING',
  POST_LISTING = 'POST_LISTING',
  PUT_LISTING = 'PUT_LISTING',
  STORE_LISTINGS = 'STORE_LISTINGS',
  STORE_LISTING = 'STORE_LISTING',
  LOADING_LISTINGS = 'LOADING_LISTINGS',
  GET_PARTNER_LISTING = 'GET_PARTNER_LISTING',
  STORE_PARTNER_LISTINGS = 'STORE_PARTNER_LISTINGS',
}
